import { useContext }from 'react'
import { fs } from '../controls/Constants'
import { Store } from '../App';
import emoji from "emoji-dictionary"
import CodeFormatter from '../components/CodeFormatter';

const Resources = () => {
    const image = useContext(Store);
    return (
        <div>
           <main>
            <section>
                <h1 className='text-center'>Getting Started with Kari</h1>
                <p className={fs}>To get started with kari you have to download the kari libary.  <br />
                To do that head over to the download section and hit the download button to download the kari library<br />
                into your computer.
                </p>
                </section>
                <section>
                <h2 className='text-center'>{emoji.getUnicode("inbox_tray")} Step 1: Download the Kari IoT Library</h2>
                <div className='img-medium-cont'>
                <img src={image?.download} className="img-medium"alt="download pic"/>
                </div>
                <p className={fs}>Click on the download button to download the kari library zip file</p>
            </section>
            <br/>
            <section>
            <h2 className='text-center'>{emoji.getUnicode("file_folder")} Step 2: Extract the Library Files</h2>
            <ol className={fs}>
                <li>Locate the downloaded kari.zip file.</li>
                <li>Right-click the file and choose "Extract Here" or "Extract to kari" (depending on your system).</li>
                <li>This will create a folder named kari.</li>
            </ol>
            </section>
            <section>
            <h2 className='text-center'>{emoji.getUnicode("file_folder")} Step 3: Move the Library to the Arduino Libraries Folder</h2>
            <p className={fs}>To use the Kari IoT Library, it must be placed in the Arduino libraries directory.</p>
            <article>
                <h3>{emoji.getUnicode("small_blue_diamond")} Windows</h3>
                <ol>
                    <li>Open File Explorer and navigate to:
                        <CodeFormatter
                        lang="plaintext"
                        codeSnippet='C:\Users\<YourUsername>\Documents\Arduino\libraries\'
                        />
                    </li>
                    <li>Copy the kari folder into the libraries folder.</li>
                </ol>
            </article>
            <article>
                <h3>{emoji.getUnicode("small_blue_diamond")} macOS</h3>
                <ol>
                    <li>Open Finder and go to:
                        <CodeFormatter
                        lang="plaintext"
                        codeSnippet='~/Documents/Arduino/libraries/'
                        />
                    </li>
                    <li>Drag and drop the kari folder inside.</li>
                </ol>
            </article>
            <article>
                <h3>{emoji.getUnicode("small_blue_diamond")} Linux</h3>
                <ol>
                    <li>Open a terminal and run:
                        <CodeFormatter
                        lang="plaintext"
                        codeSnippet='mv ~/Downloads/kari-iot-library ~/Arduino/libraries/'
                        />
                    </li>
                    <li>Press Enter to move the library.</li>
                </ol>
            </article>
            </section>
            <section>
            <h2 className='text-center'>{emoji.getUnicode("arrows_clockwise")} Step 4: Restart Arduino IDE</h2>
            <ol className={fs}>
                <li>Close Arduino IDE if it's open.</li>
                <li>Reopen Arduino IDE to load the new library.</li>
            </ol>
            </section>
            <section>
            <h2 className='text-center'>{emoji.getUnicode("white_check_mark")} Step 5: Verify Installation and Use the Library</h2>
            <ol className={fs}>
                <li>Open Arduino IDE</li>
                <li>Click Sketch → Include Library and check if kari appears in the list.</li>
                <li>To test the library:
                    <ul>
                        <li>Click File → Examples.</li>
                        <li>Scroll till you find kari </li>
                        <li>Open a sample sketch and upload it to your board.</li>
                        <li>Alternatively, Click File → Open.</li>
                        <li>Navigate to Arduino/libraries/kari/examples/</li>
                        <li>Open a sample sketch and upload it to your board.</li>
                    </ul>
                </li>
            </ol>
            </section>
            <p className="fs-20">{emoji.getUnicode("tada")} Success! You have installed the Kari IoT Library manually. 
                You can now start using it in your Arduino projects</p>
           </main>
        </div>
    )
}

export default Resources
